import React from 'react';
import { KiteIcon } from '@kite/react-kite';
import { SmartLink } from '../SmartLink/SmartLink';

export const CollapsibleTableRowChild = ({ node }) => {
    const mainText = node.field_main_text;
    const secondaryText = node.field_secondary_text;
    const nestedURL = node.field_url;

    const LinkedContent = () => {
        return (
            <>
                <SmartLink
                    url={nestedURL}
                    ariaLabel={`Go to ${mainText}`}
                    newWindow
                >
                    <span className="link">
                        {secondaryText ?? `View Release`}
                        <KiteIcon size="0.75rem" icon="ki-chevron-right" />
                    </span>
                </SmartLink>
            </>
        );
    };

    const FlatContent = () => {
        return (
            <>
                <span className="">{secondaryText}</span>
            </>
        );
    };

    return (
        <li className="paragraph__collapsible_table_row child">
            <span className="main-text">{mainText}</span>
            {nestedURL ? <LinkedContent /> : <FlatContent />}
        </li>
    );
};
